// extracted by mini-css-extract-plugin
export default {"titulo":"style_titulo__Vyx7-","frameworkTitleBackground":"style_frameworkTitleBackground__EyyPq","playlistITemTitle":"style_playlistITemTitle__B1C1V"};